export const MODULE_ID = 'notifications';
export const NOTIFICATIONS_LIST_LENGTH = 8;
export const NOTIFICATIONS_RANGE_POPUP = `${MODULE_ID}/NOTIFICATIONS_RANGE_POPUP`;
export const RANGE_PICKER_POPUP = 'NotificationFiltersRangePickerPopUp';
export const NOTIFICATIONS_SETTINGS_MODAL = `${MODULE_ID}/NOTIFICATIONS_SETTINGS_MODAL`;
export const NOTIFICATIONS_SETTINGS_FORM = `${MODULE_ID}.NotificationsSettingsForm`;
export const NOTIFICATIONS_FILTERS_FORM = `${MODULE_ID}.NotificationFiltersForm`;
export const NOTIFICATIONS_TRIGGERS = {
    CLINIC_PATIENT_PROFILE_CREATED: 'ClinicPatientProfileCreated',
    PATIENT_PROFILE_DELETED: 'PatientProfileDeleted',
    CLINIC_PATIENT_PROFILE_NEW_DATA_SYNCHRONIZED: 'ClinicPatientProfileNewDataSynchronized',
    CLINIC_HCP_MEMBERSHIP_CREATED: 'ClinicHcpMembershipCreated',
    CLINIC_MEMBERSHIP_APPROVED: 'ClinicMembershipApproved',
    CLINIC_MEMBERSHIP_REJECTED: 'ClinicMembershipRejected',
    SHARING_REQUEST_ACCEPTED: 'SharingRequestAccepted',
    SHARING_REQUEST_REJECTED: 'SharingRequestRejected',
    SHARING_REQUEST_INVITATION_REJECTED: 'SharingRequestInvitationRejected',
    SHARING_REQUEST_INVITATION_ACCEPTED: 'SharingRequestInvitationAccepted',
    SHARING_REQUEST_REVOKED: 'SharingRequestRevoked',
    RECEIVED_HCP_INVITATION: 'ReceivedHcpInvitation',
    HCP_INVITATION_APPROVED: 'HcpInvitationApproved',
    HCP_INVITATION_REJECTED: 'HcpInvitationRejected',
    PWD_INVITATION_CREATED: 'PwdInvitationCreated',
    PWD_INVITATION_FOUNDED: 'PwdInvitationFounded',
    PWD_INVITATION_REVOKED: 'PwdInvitationRevoked',
    NEW_PWD_DATA_FROM_SHARE_LINK_DOWNLOADED: 'NewPwdDataFromShareLinkDownloaded',
    NOTE_WRITTEN_BY_HCP: 'NoteWrittenByHcp',
    NOTE_WRITTEN_BY_PWD: 'NoteWrittenByPwd',
    FAMILY_LINK_INVITATION_ACCEPTED: 'FamilyLinkInvitationAccepted',
    FAMILY_LINK_REVOKED: 'FamilyLinkRevoked',
    PATIENT_ENROLLED_TO_CLINIC: 'PatientEnrolledToClinic',
    LEAD_HCP_REASSIGNED: 'LeadHcpReassigned'
};
export const NOTIFICATIONS_STATUSES = {
    Active: 'Active',
    Read: 'Read',
    Dismissed: 'Dismissed'
};
export const DEFAULT_NOTIFICATION_FILTER = {
    start: 0,
    limit: NOTIFICATIONS_LIST_LENGTH,
    fromTimestamp: null,
    toTimestamp: null,
    notificationTriggers: [],
    notificationStatuses: [
        NOTIFICATIONS_STATUSES.Active,
        NOTIFICATIONS_STATUSES.Read
    ]
};
export const NOTIFICATION_LINKS = {
    FAMILY_MEMBER: 'FamilyMemberLink',
    PATIENT_PROFILE: 'PatientProfileLink',
    CLINIC: 'ClinicLink',
    VISIT_NOTES: 'VisitNotesLink'
};
